// Smart Sash Admin Panel - Scope Models
// User access scope related types

/**
 * Scope type enum matching backend ScopeType (string values per v2 API)
 */
export enum ScopeType {
  Institution = 'Institution',
  Group = 'Group',
  Lab = 'Lab',
  Device = 'Device',
}

export interface AssignmentDTO {
  id: string;
  institutionId: string;
  userId: string;
  roleId: string;
  roleName?: string | null;
  scopeType: ScopeType;
  scopeId: string;
  validFrom: string;
  validUntil?: string | null;
  revokedAt?: string | null;
  revokedBy?: string | null;
  grantedBy: string;
  isActive: boolean;
  createdAt: string;
}

export interface CreateAssignmentRequest {
  roleId: string;
  scopeType: ScopeType;
  scopeId: string;
  validFrom?: string | null;
  validUntil?: string | null;
}
